import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { Box, Title, Button, Text } from "@mantine/core";

import { AddressDisplay, GET_USER, STYLE } from "@jasper/shared";

const UserView = () => {
  const { user_id } = useParams();

  const navigate = useNavigate();

  const { data } = useQuery(GET_USER, {
    variables: {
      where: {
        id: user_id,
      },
    },
    fetchPolicy: "network-only",
  });

  return (
    <>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          width: "100%",
          gap: "20px",
        }}
      >
        <Box
          span={5}
          style={{
            border: "0.01rem solid lightgrey",
            padding: "3rem",
            margin: "1rem",
          }}
        >
          <Title style={{ textAlign: "center", marginBottom: "2rem" }} fw={200}>
            General informations
          </Title>
          <div>
            <span style={{ fontWeight: "bold" }}>Firstname:</span>{" "}
            {data?.user?.firstName}
            <br />
            <span style={{ fontWeight: "bold" }}>Lastname:</span>{" "}
            {data?.user?.lastName}
            <br />
            <span style={{ fontWeight: "bold" }}>Email:</span>{" "}
            {data?.user?.email}
            <br />
            <span style={{ fontWeight: "bold" }}>Role:</span> {data?.user?.role}
            <br />
            <span style={{ fontWeight: "bold" }}>Type:</span> {data?.user?.type}
            <br />
            <span style={{ fontWeight: "bold" }}>Status:</span>{" "}
            {data?.user?.status}
          </div>
        </Box>
        {(data?.user?.userGroup?.addresses ?? []).length > 0 && (
          <Box
            style={{
              border: "0.01rem solid lightgrey",
              padding: "3rem",
              margin: "1rem",
            }}
          >
            <Title
              style={{ textAlign: "center", marginBottom: "2rem" }}
              fw={200}
            >
              Address
            </Title>
            <AddressDisplay address={data?.user?.userGroup?.addresses[0]} />
          </Box>
        )}
        <Box
          style={{
            border: "0.01rem solid lightgrey",
            padding: "3rem",
            margin: "1rem",
          }}
        >
          <Title style={{ textAlign: "center", marginBottom: "2rem" }} fw={200}>
            Clinic
          </Title>
          <div>
            <Text>
              <span style={{ fontWeight: "bold" }}>Group:</span>{" "}
              <span
                style={{ textDecoration: "underline", cursor: "pointer" }}
                onClick={() => navigate(`/groups/${data?.user?.userGroup?.id}`)}
              >
                {data?.user?.userGroup?.name}
              </span>
            </Text>
            <Text>
              <span style={{ fontWeight: "bold" }}>Clinic number:</span>{" "}
              {data?.user?.userGroup?.clinicNumber}
            </Text>
            <Text>
              <span style={{ fontWeight: "bold" }}>Master account:</span>{" "}
              {data?.user?.isManager ? "YES" : "NO"}
            </Text>
            {data?.user?.phoneNumber &&
              data?.user?.phoneNumber !== "NOT_PROVIDED" && (
                <Text>
                  <span style={{ fontWeight: "bold" }}>Phone number:</span>{" "}
                  {data?.user?.phoneNumber}
                </Text>
              )}
          </div>
        </Box>
        <Box
          style={{
            border: "0.01rem solid lightgrey",
            padding: "3rem",
            margin: "1rem",
          }}
        >
          <Title style={{ textAlign: "center", marginBottom: "2rem" }} fw={200}>
            Billing
          </Title>
          <div>
            <span style={{ fontWeight: "bold" }}>Pricing type:</span>{" "}
            {data?.user?.userGroup?.clientBilling?.pricingType || "N/A"}
            <br />
            <Text
              style={{
                fontStyle: "italic",
                fontSize: "0.9rem",
                marginTop: "0.5rem",
              }}
            >
              (Pricing is managed at the group level)
            </Text>
          </div>
        </Box>
      </div>
      <div style={{ textAlign: "center" }}>
        <Button
          style={{ backgroundColor: STYLE.primary }}
          onClick={() =>
            navigate(`/users/${user_id}/edit`, { state: { user: data.user } })
          }
        >
          Edit user
        </Button>
      </div>
    </>
  );
};

export default UserView;
